import { CITIES_TR } from '../../data/citiesTR'
import emailjs from '@emailjs/browser'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from 'react-i18next'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'
import s from './DemandForm.module.css'

const RECAPTCHA_SITE_KEY = '6LcWL8YrAAAAAG7Bh7yUYrmjeMQcRPZ6B7qaBYhS'
const EMAILJS_SERVICE_ID = 'service_23hhm2k'
const EMAILJS_TEMPLATE_ID = 'template_ygbm5dj'
const EMAILJS_PUBLIC_KEY = 'WxFann324-3TLjm9L'

export const DemandForm = () => {
	const { t } = useTranslation()

	const formRef = useRef(null)
	const recaptchaRef = useRef(null)

	const [recaptchaToken, setRecaptchaToken] = useState(null)
	const [submitting, setSubmitting] = useState(false)

	const [successOpen, setSuccessOpen] = useState(false)
	const [errorOpen, setErrorOpen] = useState(false)
	const [alertMsg, setAlertMsg] = useState('')

	const [phone, setPhone] = useState('')

	const handleClose = (_, reason) => {
		if (reason === 'clickaway') return
		setSuccessOpen(false)
		setErrorOpen(false)
	}

	const sendEmail = e => {
		e.preventDefault()

		const token = recaptchaRef.current?.getValue()
		if (!token) {
			setAlertMsg(t('captcha'))
			setErrorOpen(true)
			return
		}
		const hidden = formRef.current?.querySelector(
			'input[name="g-recaptcha-response"]'
		)
		if (hidden) hidden.value = token

		setSubmitting(true)
		emailjs
			.sendForm(
				EMAILJS_SERVICE_ID,
				EMAILJS_TEMPLATE_ID,
				formRef.current,
				EMAILJS_PUBLIC_KEY
			)
			.then(() => {
				setAlertMsg(t('success'))
				setSuccessOpen(true)
				e.target.reset()
				setPhone('')
				setRecaptchaToken(null)
				recaptchaRef.current?.reset()
			})
			.catch(() => {
				setAlertMsg(t('error'))
				setErrorOpen(true)
				setRecaptchaToken(null)
				recaptchaRef.current?.reset()
			})
			.finally(() => setSubmitting(false))
	}

	return (
		<div className={s.DemandForm}>
			<h3>{t('demand-form')}</h3>
			<div className='container'>
				<div className={s.Wrapper}>
					<form ref={formRef} onSubmit={sendEmail} className={s.Form}>
						<label htmlFor='company'>{t('company')}</label>
						<input
							placeholder='Company title'
							id='company'
							name='company'
							type='text'
						/>

						<label htmlFor='city'>{t('city')}</label>
						<select id='city' name='city' defaultValue='Select city'>
							<option value='Select city'>Select City</option>
							{CITIES_TR.map(c => (
								<option key={c} value={c}>
									{c}
								</option>
							))}
						</select>

						<label htmlFor='person'>{t('contact-person')}</label>
						<input
							placeholder='Contact person'
							id='person'
							name='person'
							type='text'
						/>

						<label htmlFor='phone'>{t('phone')}</label>
						<div className={s.Phone}>
							<PhoneInput
								defaultCountry='tr'
								value={phone}
								onChange={setPhone}
								international
								countrySelectorScrollable
								className={s.fullWidthPhone}
							/>
						</div>
						<input type='hidden' name='phone' value={phone} />

						<label htmlFor='email'>{t('email')}</label>
						<input placeholder='Email' id='email' name='email' type='email' />

						<label htmlFor='totalEmployers'>
							{t('current-number-workers')}
						</label>
						<input
							placeholder='Current number of employers'
							id='totalEmployers'
							name='totalEmployers'
							type='text'
						/>

						<label htmlFor='requestedWorkers'>{t('request-workers')}</label>
						<div className={s.requestedWorkers}>
							<input
								id='requestedWorkers'
								placeholder='Position'
								name='pos1'
								type='text'
							/>
							<input
								id='requestedWorkers'
								placeholder='No.'
								name='no1'
								type='text'
							/>
						</div>
						<div className={s.requestedWorkers}>
							<input
								id='requestedWorkers'
								placeholder='Position'
								name='pos2'
								type='text'
							/>
							<input
								id='requestedWorkers'
								placeholder='No.'
								name='no2'
								type='text'
							/>
						</div>
						<div className={s.requestedWorkers}>
							<input
								id='requestedWorkers'
								placeholder='Position'
								name='pos3'
								type='text'
							/>
							<input
								id='requestedWorkers'
								placeholder='No.'
								name='no3'
								type='text'
							/>
						</div>
						<div className={s.requestedWorkers}>
							<input
								id='requestedWorkers'
								placeholder='Position'
								name='pos4'
								type='text'
							/>
							<input
								id='requestedWorkers'
								placeholder='No.'
								name='no4'
								type='text'
							/>
						</div>

						<textarea
							id='textComment'
							placeholder='Comment'
							name='textComment'
						></textarea>

						<input
							type='hidden'
							name='g-recaptcha-response'
							value={recaptchaToken || ''}
						/>
						<ReCAPTCHA
							ref={recaptchaRef}
							sitekey={RECAPTCHA_SITE_KEY}
							onChange={t => setRecaptchaToken(t)}
							onExpired={() => setRecaptchaToken(null)}
						/>

						<input
							type='submit'
							value={submitting ? 'Sending...' : 'Send'}
							disabled={submitting}
						/>
					</form>
				</div>

				<Snackbar
					open={successOpen}
					autoHideDuration={3000}
					onClose={handleClose}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<MuiAlert
						onClose={handleClose}
						severity='success'
						variant='filled'
						elevation={6}
					>
						{alertMsg || t('success')}
					</MuiAlert>
				</Snackbar>

				<Snackbar
					open={errorOpen}
					autoHideDuration={4000}
					onClose={handleClose}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<MuiAlert
						onClose={handleClose}
						severity='error'
						variant='filled'
						elevation={6}
					>
						{alertMsg || t('error')}
					</MuiAlert>
				</Snackbar>
			</div>
		</div>
	)
}
